module.exports = __webpack_public_path__ + "MtnGraphic-393bf7edd33b775090dbedf563dee326.svg";